"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var I18NextProvider_1 = require("./I18NextProvider");

var NamespaceProvider_1 = require("./NamespaceProvider");

var childrenToNamespacedKey = function childrenToNamespacedKey(ns, children) {
  var key = children.trim();

  if (ns) {
    return ns + ":" + key;
  }

  return key;
}; // @ts-ignore


var Translate = function Translate(_a) {
  var children = _a.children,
      interpolate = _a.interpolate;
  return React.createElement(I18NextProvider_1.I18NextConsumer, null, function (_a) {
    var i18n = _a.i18n;
    return React.createElement(NamespaceProvider_1.NameSpaceConsumer, null, function (ns) {
      return i18n.t(childrenToNamespacedKey(ns, children), interpolate);
    });
  });
}; // @ts-ignore


exports.default = Translate;